import { h, Fragment } from 'preact';
import RequestQueue from 'classes/RequestQueue';
import { useState } from 'preact/hooks';
import Utility from 'classes/Utility';

const colorMapping = {
  table: {
    strokeColor: '#2542D0',
    borderColor: '#2542D0',
    buttonSelected: {
      backgroundColorClass: 't-flex t-justify-center t-text-mitre-blue-200 hover:t-text-mitre-blue-300'
    },
    buttonUnselected: {
      backgroundColorClass: 't-flex t-justify-center t-text-white hover:t-text-mitre-gray-200'
    }
  },
  searchCenter: {
    strokeColor: '#FFFFFF',
    borderColor: '#FFFFFF',
    buttonSelected: {
      backgroundColorClass: 't-text-transparent m-table-watchlist-button-bg-search-center__active'
    },
    buttonUnselected: {
      backgroundColorClass: 't-text-transparent m-table-watchlist-button-bg-search-center__inactive'
    }
  }
}

const WatchlistButton = ({ state, securityType, isPremium, symbol, type = 'table' }) => {
  const colors = colorMapping[type];
  const [buttonState, setState] = useState(state);
  const toggleState = () => {
    setState(prevState => {
      if (prevState === 'true') {
        // Update watchlist settings
        RequestQueue.addToQueue({
          url: `/api/dividend/watch_list/${symbol}/`,
          method: 'delete',
          data: {
            security_type: securityType
          }
        }).then(response => {
          const { data } = response;
          const { security_id } = data;
          EventManager.emit('watchlist-updated', {
            securityId: security_id,
            action: 'remove'
          })
          window.EventManager.emit('flash-message', {
            status: 'INFO',
            title: 'Removed from your Watchlist',
            dslName: 'ConfirmationMessageRemovedFromWatchlist'
          })
        })
        return 'false'
      } else {
        RequestQueue.addToQueue({
          url: `/api/dividend/watch_list/${symbol}/`,
          method: 'put',
          data: {
            security_type: securityType
          }
        }).then(() => {
          window.EventManager.emit('flash-message', {
            status: 'INFO',
            title: 'Added to your Watchlist',
            dslName: 'ConfirmationMessageAddToWatchlist'
          })
        })
        return 'true'
      }
    })
  };

  const additionalProps = !isPremium ? {
    'data-controller': 'cta-modal',
    'data-modal-key': 'TblColAddToWatchlist',
    'data-modal-url': '/api/dividend/cta-content/',
    'data-modal-location': 'table',
    'data-action': 'click->cta-modal#showModal',
  } : {
      onClick: toggleState
    };

  return (
    type == 'searchCenter' && Utility.getDeviceType() !== 'dt' ? (
      <FullWatchlistButtonIcon
        data-dsl-name={buttonState === 'true' ? 'FormFieldWatchlistRemoveSubmit' : 'FormFieldWatchlistAddSubmit'}
        state={buttonState}
        {...additionalProps}
      />
    ) : (
      <SimpleWatchlistButtonIcon
        data-dsl-name={buttonState === 'true' ? 'FormFieldWatchlistRemoveSubmit' : 'FormFieldWatchlistAddSubmit'}
        state={buttonState}
        colors={colors}
        {...additionalProps}
      />
    )
  )
}

  //   <button
  //     className={
  //       buttonState === 'true'
  //         ? colors.buttonSelected.backgroundColorClass
  //         : colors.buttonUnselected.backgroundColorClass
  //     }
  //     {...additionalProps}
  //   >
  //     {
  //       buttonState === 'true' ? (
  //         <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  //           <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" fill="currentColor" stroke={colors.borderColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //           <path d="M10 16H22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //         </svg>
  //       ) : (
  //           <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  //             <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //             <path d="M16 10.0002V22.0002" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //             <path d="M10.0002 16H22.0002" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  //           </svg>
  //         )
  //     }
  //   </button>
  // )
const FullWatchlistButtonIcon = ({ state, ...additionalProps }) => (
  <button
    {...additionalProps}
    className="t-flex t-rounded t-border t-px-3 t-py-2 hover:t-bg-gray-700 t-flex-none t-self-center"
  >
  {
    state === 'true' ? (
      <Fragment>
        <span className="t-text-white">Remove from Watchlist</span>
        <span className="t-pl-3 t-hidden md:t-block">
          <svg width="23px" height="22px" viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Search-bar-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Search-screen---Suggested-Search---Watchlist-added-for-Premium-user" transform="translate(-960.000000, -214.000000)" fill="#FFFFFF" fillRule="nonzero">
                <g id="Group" transform="translate(960.384000, 214.384000)">
                  <path d="M18.1001332,6.74870179 C19.1006234,6.06455108 19.712,4.93144846 19.712,3.696 C19.712,1.65475556 18.0572444,2.84217094e-14 16.016,2.84217094e-14 C14.6201858,2.84217094e-14 13.3627745,0.78099296 12.7323698,1.998083 L13.8263327,2.56471271 C14.2470349,1.75248451 15.0850234,1.232 16.016,1.232 C17.3768296,1.232 18.48,2.33517038 18.48,3.696 C18.48,4.52030696 18.0728908,5.27482794 17.4047163,5.73173606 L18.1001332,6.74870179 Z" id="Shape"></path>
                  <path d="M5.43678193,6.74870179 C6.43727215,6.06455108 7.04864875,4.93144846 7.04864875,3.696 C7.04864875,1.65475556 5.39389319,2.84217094e-14 3.35264875,2.84217094e-14 C1.95683454,2.84217094e-14 0.699423294,0.78099296 0.0690185617,1.998083 L1.16298144,2.56471271 C1.58368367,1.75248451 2.42167212,1.232 3.35264875,1.232 C4.71347838,1.232 5.81664875,2.33517038 5.81664875,3.696 C5.81664875,4.52030696 5.40953958,5.27482794 4.74136501,5.73173606 L5.43678193,6.74870179 Z" id="Shape-Copy" transform="translate(3.558834, 3.374351) scale(-1, 1) translate(-3.558834, -3.374351) "></path>
                  <path d="M19.712,11.088 C19.712,5.64468151 15.2993185,1.232 9.856,1.232 C4.41268151,1.232 6.82121026e-13,5.64468151 6.82121026e-13,11.088 C6.82121026e-13,16.5313185 4.41268151,20.944 9.856,20.944 C10.1962074,20.944 10.472,20.6682074 10.472,20.328 C10.472,19.9877926 10.1962074,19.712 9.856,19.712 C5.09309632,19.712 1.232,15.8509037 1.232,11.088 C1.232,6.32509632 5.09309632,2.464 9.856,2.464 C14.6189037,2.464 18.48,6.32509632 18.48,11.088 C18.48,11.4282074 18.7557926,11.704 19.096,11.704 C19.4362074,11.704 19.712,11.4282074 19.712,11.088 Z" id="Path"></path>
                  <path d="M10.5044292,10.2437011 C10.5044292,10.5839085 10.7802218,10.8597011 11.1204292,10.8597011 C11.4606366,10.8597011 11.7364292,10.5839085 11.7364292,10.2437011 L11.7364292,6.02744196 C11.7364292,5.68723456 11.4606366,5.41144196 11.1204292,5.41144196 L4.89557078,5.41144196 C4.55536337,5.41144196 4.27957078,5.68723456 4.27957078,6.02744196 C4.27957078,6.36764937 4.55536337,6.64344196 4.89557078,6.64344196 L10.5044292,6.64344196 L10.5044292,10.2437011 Z" id="Path-7-Copy-2" transform="translate(8.008000, 8.135572) rotate(90.000000) translate(-8.008000, -8.135572) "></path>
                  <path d="M13.7205953,16.6830481 C13.4526469,16.4043678 13.0095168,16.3956679 12.7308365,16.6636163 C12.4521562,16.9315647 12.4434563,17.3746948 12.7114047,17.653375 L15.6727949,20.733375 C15.9685622,21.0409884 16.4683896,21.0146473 16.7301855,20.67765 L22.193151,13.6454384 C22.4303233,13.340138 22.3750945,12.900377 22.0697941,12.6632047 C21.7644936,12.4260324 21.3247326,12.4812612 21.0875604,12.7865616 L16.1210777,19.1796748 L13.7205953,16.6830481 Z" id="Path-7"></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </Fragment>
    ) : (
      <Fragment>
        <span className="t-text-white t-pointer-events-none">Add to Watchlist</span>
        <span className="t-pl-3 t-hidden md:t-block t-pointer-events-none">
          <svg width="22px" height="23px" viewBox="0 0 22 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Search-bar-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Search-screen" transform="translate(-861.000000, -213.000000)" fill="#FFFFFF" fillRule="nonzero">
                <g id="Group" transform="translate(861.370800, 213.370800)">
                  <path d="M18.4879932,6.89331683 C19.5099225,6.19450575 20.1344,5.03712235 20.1344,3.7752 C20.1344,1.69021461 18.4441854,0 16.3592,0 C14.9334755,0 13.6491197,0.797728523 13.0052063,2.04089907 L14.1226112,2.61967084 C14.5523285,1.79003775 15.4082739,1.2584 16.3592,1.2584 C17.7491903,1.2584 18.876,2.38520974 18.876,3.7752 C18.876,4.61717068 18.4601671,5.38785996 17.7776745,5.85455898 L18.4879932,6.89331683 Z" id="Shape"></path>
                  <path d="M5.5532844,6.89331683 C6.57521369,6.19450575 7.19969123,5.03712235 7.19969123,3.7752 C7.19969123,1.69021461 5.50947662,0 3.42449123,0 C1.99876671,0 0.714410936,0.797728523 0.0704975309,2.04089907 L1.18790247,2.61967084 C1.61761975,1.79003775 2.47356509,1.2584 3.42449123,1.2584 C4.81448149,1.2584 5.94129123,2.38520974 5.94129123,3.7752 C5.94129123,4.61717068 5.52545828,5.38785996 4.84296569,5.85455898 L5.5532844,6.89331683 Z" id="Shape-Copy" transform="translate(3.635094, 3.446658) scale(-1, 1) translate(-3.635094, -3.446658) "></path>
                  <path d="M20.1344,11.3256 C20.1344,5.76563897 15.627161,1.2584 10.0672,1.2584 C4.50723897,1.2584 4.54747351e-13,5.76563897 4.54747351e-13,11.3256 C4.54747351e-13,16.885561 4.50723897,21.3928 10.0672,21.3928 C10.4146976,21.3928 10.6964,21.1110976 10.6964,20.7636 C10.6964,20.4161024 10.4146976,20.1344 10.0672,20.1344 C5.2022341,20.1344 1.2584,16.1905659 1.2584,11.3256 C1.2584,6.4606341 5.2022341,2.5168 10.0672,2.5168 C14.9321659,2.5168 18.876,6.4606341 18.876,11.3256 C18.876,11.6730976 19.1577024,11.9548 19.5052,11.9548 C19.8526976,11.9548 20.1344,11.6730976 20.1344,11.3256 Z" id="Path"></path>
                  <path d="M10.7295241,10.463209 C10.7295241,10.8107066 11.0112266,11.092409 11.3587241,11.092409 C11.7062217,11.092409 11.9879241,10.8107066 11.9879241,10.463209 L11.9879241,6.15660144 C11.9879241,5.80910387 11.7062217,5.52740144 11.3587241,5.52740144 L5.00047586,5.52740144 C4.6529783,5.52740144 4.37127586,5.80910387 4.37127586,6.15660144 C4.37127586,6.504099 4.6529783,6.78580144 5.00047586,6.78580144 L10.7295241,6.78580144 L10.7295241,10.463209 Z" id="Path-7-Copy-2" transform="translate(8.179600, 8.309905) rotate(90.000000) translate(-8.179600, -8.309905) "></path>
                  <path d="M15.73,13.2132 L15.73,22.022 C15.73,22.3694976 16.0117024,22.6512 16.3592,22.6512 C16.7066976,22.6512 16.9884,22.3694976 16.9884,22.022 L16.9884,13.2132 C16.9884,12.8657024 16.7066976,12.584 16.3592,12.584 C16.0117024,12.584 15.73,12.8657024 15.73,13.2132 Z" id="Path-7-Copy-3"></path>
                  <path d="M15.73,13.2132 L15.73,22.022 C15.73,22.3694976 16.0117024,22.6512 16.3592,22.6512 C16.7066976,22.6512 16.9884,22.3694976 16.9884,22.022 L16.9884,13.2132 C16.9884,12.8657024 16.7066976,12.584 16.3592,12.584 C16.0117024,12.584 15.73,12.8657024 15.73,13.2132 Z" id="Path-7-Copy-4" transform="translate(16.359200, 17.617600) rotate(-90.000000) translate(-16.359200, -17.617600) "></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </Fragment>
    )
  }
  </button>
)

const SimpleWatchlistButtonIcon = ({state, colors, ...additionalProps }) => (
  <button
    className={
      state === 'true'
        ? colors.buttonSelected.backgroundColorClass
        : colors.buttonUnselected.backgroundColorClass
    }
    {...additionalProps}
  >
    {
      state === 'true' ? (
        <svg width="32" height="fill" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" fill="currentColor" stroke={colors.borderColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M10 16H22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
          <svg width="32" height="fill" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 10.0002V22.0002" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.0002 16H22.0002" stroke={colors.strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )
    }
  </button>
)

    export default WatchlistButton;
